var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGender(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    fillRule: "evenodd",
    clipRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 358.5h-41.786c-8.284 0-15 6.716-15 15v31.75H-86.38V373.5c0-8.284-6.716-15-15-15h-41.787v-29.59h41.787c8.284 0 15-6.716 15-15V158.98a15 15 0 0 0-11.03-14.465c-42.122-11.563-71.541-50.174-71.541-93.895 0-53.69 43.68-97.37 97.368-97.37 53.688 0 97.367 43.68 97.367 97.37 0 43.721-29.419 82.332-71.541 93.895a15 15 0 0 0-11.029 14.465v154.93c0 8.284 6.716 15 15 15H0Zm15-59.59h-41.786V169.868c49.146-18.469 82.57-65.958 82.57-119.248 0-70.232-57.137-127.37-127.367-127.37-70.231 0-127.368 57.138-127.368 127.37 0 53.29 33.424 100.779 82.571 119.248V298.91h-41.787c-8.284 0-15 6.716-15 15v59.59c0 8.284 6.716 15 15 15h41.787v31.75c0 8.284 6.715 15 15 15h59.594c8.284 0 15-6.716 15-15V388.5H15c8.284 0 15-6.716 15-15v-59.59c0-8.284-6.716-15-15-15",
    transform: "translate(200.582 76.75)",
    fillRule: "nonzero",
    fill: "#ff7b26",
    className: "fill-000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 69.98c-19.295 0-34.993-15.697-34.993-34.99C-34.993 15.696-19.295 0 0 0c19.294 0 34.992 15.696 34.992 34.99 0 19.293-15.698 34.99-34.992 34.99m64.992-34.99C64.992-.846 35.836-30 0-30-35.837-30-64.993-.846-64.993 34.99S-35.837 99.98 0 99.98c35.836 0 64.992-29.154 64.992-64.99",
    transform: "translate(128.999 92.38)",
    fillRule: "nonzero",
    fill: "#ff7b26",
    className: "fill-000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 69.99c-19.295 0-34.993-15.701-34.993-35C-34.993 15.697-19.295 0 0 0c19.294 0 34.992 15.697 34.992 34.99 0 19.299-15.698 35-34.992 35M0-30C-35.837-30-64.993-.846-64.993 34.99c0 35.841 29.156 65 64.993 65 35.836 0 64.992-29.159 64.992-65C64.992-.846 35.836-30 0-30",
    transform: "translate(383.002 349.64)",
    fillRule: "nonzero",
    fill: "#ff7b26",
    className: "fill-000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 448.74c-53.689 0-97.368-43.68-97.368-97.37 0-43.72 29.419-82.332 71.541-93.895a15 15 0 0 0 11.03-14.465V86.74a15 15 0 0 0-25.604-10.609l-13.201 13.193a14.696 14.696 0 0 1-10.462 4.329 14.696 14.696 0 0 1-10.462-4.329c-5.769-5.77-5.769-15.158-.001-20.927l64.065-64.062A14.699 14.699 0 0 1 0 0c3.951 0 7.666 1.54 10.462 4.337l64.063 64.059c5.769 5.77 5.769 15.158 0 20.928a14.696 14.696 0 0 1-10.462 4.329 14.7 14.7 0 0 1-10.466-4.332l-13.196-13.19A14.999 14.999 0 0 0 14.797 86.74v156.27a15 15 0 0 0 11.029 14.465c42.122 11.563 71.541 50.175 71.541 93.895 0 53.69-43.679 97.37-97.367 97.37m44.797-216.618V119.327c5.94 2.832 12.488 4.326 19.266 4.326 11.97 0 23.22-4.659 31.677-13.117 17.463-17.466 17.463-45.885-.001-63.353L31.678-16.874C23.217-25.338 11.967-30 0-30c-11.967 0-23.218 4.661-31.677 13.123L-95.74 47.184c-17.465 17.466-17.465 45.886-.001 63.351 8.457 8.459 19.707 13.118 31.677 13.118 6.779 0 13.327-1.494 19.267-4.326v112.795c-49.147 18.469-82.571 65.958-82.571 119.248 0 70.232 57.137 127.37 127.368 127.37 70.23 0 127.367-57.138 127.367-127.37 0-53.29-33.424-100.779-82.57-119.248",
    transform: "translate(383.002 33.26)",
    fillRule: "nonzero",
    fill: "#ff7b26",
    className: "fill-000000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGender);
export default __webpack_public_path__ + "static/media/gender.bca703543ac1dea4a8fb367968aa7396.svg";
export { ForwardRef as ReactComponent };